import {
    TableCell,
    TableRow
} from '@mui/material';
import React from 'react';
import { UtenteLink } from './UtenteLink';

export const UtenteTableRow = ({ label, utenteId, ...props }) => {
    return (
        <>
            <TableRow>
                <TableCell style={{ width: "20%" }}>
                    {label}
                </TableCell>
                <TableCell>
                    <UtenteLink utenteId={utenteId} />
                </TableCell>
            </TableRow>
        </>
    );
}